import { LinkHighlightButton } from '../HighlightButton/HighlightButton';

import styles from '../../css/Home.module.css';

function Home() {
  const handleButtonClick = async (buttonTitle) => {
    try {
      const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');

      logAnalyticsEvent('code_home_button_click', {
        button_title: buttonTitle
      });
    } catch (error) {
      console.error('Failed to log analytics event:', error);
    }
  }

  return (
    <main className="mainContainer centeredVertically">
      {/* <div className="profileImageContainer">
        <img shadow={5} className="profileImage" alt="Lawrence Luo portrait" src={"/static/img/law_cropped.png"}></img>
      </div> */}

      <section>
        <div className={styles.superscript}><em>greetings from</em></div>
        <h1>LAWRENCE LUO</h1>
        <p className={styles.description}>
          I create web and mobile apps that are refreshing to use and effortless to explore. My 7+ years of experience include developing and optimizing responsive applications using React, TypeScript, and Next.js.
        </p>

        <div style={{ display: 'flex', gap: 10 }}>
          <LinkHighlightButton
            to="/projects"
            onClick={() => handleButtonClick('PROJECTS')}
          >
            PROJECTS
          </LinkHighlightButton>

          <LinkHighlightButton
            to="/work"
            onClick={() => handleButtonClick('WORK')}
          >
            WORK
          </LinkHighlightButton>
        </div>
      </section>
    </main>
  )
}

export default Home;
